import type { SucceedUserSessionResponse } from '../types/succeed-user-session';
import {
  SUCCEED_PRODUCT_COURSE_PLANNER_NEXT,
  SucceedUserLevel,
} from '../types/succeed-user-session';

/** JSON key for Course Planner Next in `products` (same as `String(SUCCEED_PRODUCT_COURSE_PLANNER_NEXT)`). */
const COURSE_PLANNER_NEXT_PRODUCT_KEY = String(SUCCEED_PRODUCT_COURSE_PLANNER_NEXT);

/**
 * Course Planner Next product scope from Succeed GET `/user?product=7` (`products['7']`).
 * Mirrors course-planner-ui `userSession.reducer` / reports-v3 `ProductLevel`.
 * Populated by {@link AuthProvider} after session fetch; read from cp-context for embed gating.
 */
let coursePlannerProductLevel: string | undefined;

export function setSucceedCoursePlannerProductLevelFromSession(
  session: SucceedUserSessionResponse | null | undefined
): void {
  if (!session?.products || typeof session.products !== 'object') {
    coursePlannerProductLevel = undefined;
    return;
  }
  const products = session.products as Record<string, unknown>;
  const raw = products[COURSE_PLANNER_NEXT_PRODUCT_KEY];
  if (raw === null || raw === undefined || raw === '') {
    coursePlannerProductLevel = undefined;
    return;
  }
  coursePlannerProductLevel = typeof raw === 'string' ? raw : String(raw);
}

/**
 * True when the staff session says Course Planner Next is scoped as `SCHOOL_INDIVIDUAL`:
 * the school holds the product (district does not), so the school operates without district CP control.
 * Aligns with reports-v3 `ProductLevel.SCHOOL_INDIVIDUAL` / c-p-ui `USER_LEVEL.SCHOOL_INDIVIDUAL`.
 */
export function isSchoolIndividualCoursePlannerProductLevel(): boolean {
  return coursePlannerProductLevel === SucceedUserLevel.SCHOOL_INDIVIDUAL;
}
